module.exports = __webpack_public_path__ + "img/arch2.1fad57ac.svg";